const MULTI_PART_EXTENSIONS = new Set([
  'tar.gz',
  'tar.bz2',
  'tar.xz',
])

export const getFileExtension = (file: File): string => {
  const name = file.name.toLowerCase()

  for (const ext of MULTI_PART_EXTENSIONS) {
    if (name.endsWith(`.${ext}`)) {
      return ext
    }
  }

  const lastDotIndex = name.lastIndexOf('.')
  if (lastDotIndex <= 0) return ''

  return name.substring(lastDotIndex + 1)
}
